import React from 'react';
import Change_Password from './Change_Password';

const ChangePassApp = () => {
  return (
  <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Change Password</h5>
          </div>
        </div>
        <Change_Password />
      </div>
    </div >

  );
};

export default ChangePassApp;
